/* eslint-disable import/prefer-default-export */
import { apiGetQCInspectionJobs, apiGetServiceProvider, apiGetInspectionTypes } from 'api';
import types from './types';

// SYNC_UPDATE_QC_INSPECTION_FILTERS
export const syncUpdateQCInspectionFilters = (key, data) => {
  return {
    type: types.SYNC_UPDATE_QC_INSPECTION_FILTERS,
    payload: { key, data },
  };
};
// GET_QC_INSPECTION_ALL_JOBS
export const getQCInspectionAllJobs = (filters, cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_QC_INSPECTION_ALL_JOBS,
    asyncCall: () => {
      return apiGetQCInspectionJobs({
        ...(filters || {}),
        recordType: 'all',
      });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_QC_INSPECTION_THIRD_PARTY_JOBS
export const getQCInspectionThirdPartyJobs = (filters, cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_QC_INSPECTION_THIRD_PARTY_JOBS,
    asyncCall: () => {
      return apiGetQCInspectionJobs({
        ...(filters || {}),
        recordType: '3rdJobs',
      });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_QC_INSPECTION_INHOUSE_JOBS
export const getQCInspectionInhouseJobs = (filters, cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_QC_INSPECTION_INHOUSE_JOBS,
    asyncCall: () => {
      return apiGetQCInspectionJobs({
        ...(filters || {}),
        recordType: 'inhouseRecords',
      });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_QC_INSPECTION_DRAFT_JOBS
export const getQCInspectionDraftJobs = (filters, cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_QC_INSPECTION_DRAFT_JOBS,
    asyncCall: () => {
      return apiGetQCInspectionJobs({
        ...(filters || {}),
        recordType: 'all',
        isPublished: false,
      });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_SERVICE_PROVIDERS
export const getServiceProviders = (filters, cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_SERVICE_PROVIDERS,
    asyncCall: () => {
      return apiGetServiceProvider(filters || {});
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_INSPECTION_TYPE
export const getInspectionTypes = (filters, cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_INSPECTION_TYPE,
    asyncCall: () => {
      return apiGetInspectionTypes(filters || {});
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
